import { render, staticRenderFns } from "./DeliverySet.vue?vue&type=template&id=3ce7746a&scoped=true&"
import script from "./DeliverySet.vue?vue&type=script&lang=tsx&"
export * from "./DeliverySet.vue?vue&type=script&lang=tsx&"
import style0 from "./DeliverySet.vue?vue&type=style&index=0&id=3ce7746a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce7746a",
  null
  
)

export default component.exports